import React from 'react';

import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';

import styles from './StakeAndReturns.scss';
import { BetIdRow } from './components/BetIdRow/BetIdRow';
import { RegulatorIdRow } from './components/RegulatorIdRow/RegulatorIdRow';
import { ReturnsRow } from './components/ReturnsRow/ReturnsRow';
import { StakeRow } from './components/StakeRow/StakeRow';

interface Props {
  receiptItem: SingleReceiptItem | MultipleReceiptItem;
}

const StakeAndReturns: React.FC<Props> = ({ receiptItem }) => {
  const { totalPotentialWin, betReceiptId, appliedBonusCash, isFreeBet, regulatorId } = receiptItem;

  const totalPotentialWinToDisplay = totalPotentialWin
    ? totalPotentialWin - (isFreeBet ? appliedBonusCash || 0 : 0)
    : 0;

  return (
    <div className={styles.meta}>
      <StakeRow receiptItem={receiptItem} />
      <ReturnsRow totalPotentialWinToDisplay={totalPotentialWinToDisplay} />
      <RegulatorIdRow regulatorId={regulatorId} />
      {betReceiptId && <BetIdRow betReceiptId={betReceiptId} />}
    </div>
  );
};

export default StakeAndReturns;
